import React from 'react';
import { Card, Table, Button, Badge } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';

const ACCENT = '#60A5FA';

const getAccountTypeBadge = (type) => {
  switch (type) {
    case 'checking':
      return <Badge bg="primary">Checking</Badge>;
    case 'savings':
      return <Badge bg="success">Savings</Badge>;
    case 'credit':
      return <Badge bg="warning" text="dark">Credit Card</Badge>;
    case 'cash':
      return <Badge bg="info">Cash</Badge>;
    case 'crypto':
      return <Badge bg="secondary">Crypto</Badge>;
    default:
      return <Badge bg="secondary">Other</Badge>;
  }
};

const BankAccounts = ({ bankAccounts, onEdit, onDelete, onAdd }) => {
  const totalBalance = bankAccounts.reduce(
    (total, account) => total + Number(account.total_balance),
    0
  );

  return (
    <Card className="bg-dark text-light border-secondary">
      <Card.Header className="d-flex justify-content-between align-items-center bg-dark border-secondary">
        <h5 className="mb-0">Accounts</h5>
        <Button
          variant="primary"
          size="sm"
          onClick={onAdd}
          style={{ backgroundColor: ACCENT, borderColor: ACCENT }}
        >
          <FaPlus className="me-2" /> Add account
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        <Table hover variant="dark" className="align-middle mb-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Balance</th>
              <th>IBAN</th>
              <th>Card</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {bankAccounts.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-4" style={{ color: '#9ca3af' }}>
                  No accounts yet. Add cash, bank, or crypto accounts you use.
                </td>
              </tr>
            ) : (
              bankAccounts.map((account) => (
                <tr key={account.id}>
                  <td style={{ fontWeight: 600 }}>{account.bank}</td>
                  <td>{getAccountTypeBadge(account.account_type)}</td>
                  <td style={{ color: Number(account.total_balance) >= 0 ? '#22c55e' : '#f87171' }}>
                    €{Number(account.total_balance).toFixed(2)}
                  </td>
                  <td style={{ color: '#9ca3af' }}>{account.iban || '—'}</td>
                  <td style={{ color: '#9ca3af' }}>
                    {account.masked_card && account.masked_card !== 'No card linked'
                      ? account.masked_card
                      : '—'}
                  </td>
                  <td className="text-end">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2"
                      onClick={() => onEdit(account)}
                      style={{ borderColor: ACCENT, color: ACCENT }}
                    >
                      <FaEdit className="me-1" /> Edit
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => onDelete(account.id)}
                    >
                      <FaTrash className="me-1" /> Delete
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
      <Card.Footer className="bg-dark border-secondary">
        <div className="d-flex justify-content-between align-items-center">
          <span style={{ color: '#9ca3af' }}>Total across accounts</span>
          <h4 className="mb-0" style={{ color: ACCENT }}>€{totalBalance.toFixed(2)}</h4>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default BankAccounts;
